const positiveFiniteNumber = (value: unknown): number => {
	const n =
		typeof value === 'number'
			? value
			: typeof value === 'string' && value.trim() !== ''
			? Number(value)
			: 0
	return Number.isFinite(n) && n > 0 ? n : 0
}

export const getSalePriceSats = (item: any): number => {
	const candidates = [
		item?.price_sats,
		item?.sale_price_sats,
		item?.escrow?.price_sats,
		item?.escrow?.satoshi_price
	]

	for (const candidate of candidates) {
		const price = positiveFiniteNumber(candidate)
		if (price > 0) return price
	}

	return 0
}

export const getSaleBoughtAt = (item: any): string => {
	const boughtAt = item?.escrow?.bought_at ?? item?.bought_at
	if (typeof boughtAt === 'string' && boughtAt.trim() !== '') return boughtAt

	const blockTimestamp = positiveFiniteNumber(item?.block_timestamp)
	return blockTimestamp > 0 ? new Date(blockTimestamp * 1000).toISOString() : ''
}

const isTxid = (v: unknown): v is string => typeof v === 'string' && /^[0-9a-f]{64}$/i.test(v)

/**
 * The transaction that settled a sale -- where the item was spent, never
 * the outpoint it sat at before (an escrow's `outpoint`). Feed rows carry it
 * as `txid`; activity rows as `escrow.purchase_txid`; pending rows as
 * `mempool.spending_txid`. Undefined when no settlement is known: no link
 * beats a link to the wrong transaction.
 */
export const getSaleTxid = (item: any): string | undefined => {
	for (const candidate of [
		item?.txid,
		item?.escrow?.purchase_txid,
		item?.purchase_txid,
		item?.mempool?.spending_txid
	]) {
		if (isTxid(candidate)) return candidate
	}
	return undefined
}
